import { render, staticRenderFns } from "./rate-list.vue?vue&type=template&id=2340beff"
import script from "./rate-list.vue?vue&type=script&lang=js"
export * from "./rate-list.vue?vue&type=script&lang=js"
import style0 from "./rate-list.vue?vue&type=style&index=0&id=2340beff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports